<div class="jw-modal mobile-modal">
    <div class="jw-modal-body mobile-modal">
        <ng-content></ng-content>
    </div>
</div>
<div class="jw-modal-background"></div>